'use strict'


const config = {
    ID : "",
    OTAP : {},
    Zapier : {},
}


export function createConfig(configIN){

        if(typeof(configIN) == "object"){
            config.ID = configIN.ID;
            config.OTAP = configIN.OTAP;
            config.Zapier = configIN.Zapier;
        }
        config.OTAP.Value = setOTAP();

        return config;
        // return {ID, OTAP, Zapier};
};


function setOTAP() {
    // Default Productie
    let Value = 0;
  
    const locURL = config.OTAP.URLLocHost;
    const ontURL = config.OTAP.URLOnt;
    const tesURL = config.OTAP.URLTes;
    const accURL = config.OTAP.URLAcc;
    const proURL = config.OTAP.URLPro;
  
    const locStatus = window.location.href.startsWith(locURL);
    const ontStatus = window.location.href.startsWith(ontURL);
    const tesStatus = window.location.href.startsWith(tesURL);
    const accStatus = window.location.href.startsWith(accURL);
    const proStatus = window.location.href.startsWith(proURL);
  
    // URL LocHost
    if (locURL != undefined && locURL != "") {
      if (locStatus) {
        Value = 3;
      }
    }
    // URL Ontwikkeling
    if (ontURL != undefined && ontURL != "") {
      if (ontStatus) {
        Value = 3;
      }
    }
    // URL Test
    if (tesURL !== undefined && tesURL !== "") {
      if (tesStatus) {
        Value = 2;
      }
    }
    // URL Acceptatie
    if (accURL && accURL !== "") {
      if (accStatus) {
        Value = 1;
      }
    }
    if (proURL && proURL !== "") {
      if (proStatus) {
        Value = 0;
      }
    }
  
    return Value;
  }
  
export {
    config
}